import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';

import { Table, TableHeaderCell } from 'core';
import { Label } from 'core/components/label';
import NoResults from '../no-results';
import { appConfig } from 'brand-config';
import OfferItem from './offer-item';
import LegacyOfferItem from './legacy-offer-item';
import useStyles from './offer-results.styles';
import useLegacyStyles from './legacy-offer-results.styles';

// [columnId, header label] for each column, in order.
const COLUMNS = [
  ['name', 'Name'],
  ['address', 'Address'],
  ['offer', 'Offer'],
  ['representative', 'Offer Rep'],
  ['updatedDateTime', 'Last updated']
];
// The columns before #36395, for brands without the offerSearchRedesign flag. Delete with
// legacy-offer-item.jsx.
const LEGACY_COLUMNS = [
  ['fname', 'First Name'],
  ['lname', 'Last Name'],
  ['address', 'Primary property location'],
  ['offers', 'Eligible Offers'],
  ['price', 'Price'],
  ['representative', 'Offer Rep'],
  ['updatedDateTime', 'Last Update']
];

const OffersResults = ({ loading, hits, totalHits, page, onPageChange, showHeader, error }) => {
  const classes = useStyles();
  const legacyClasses = useLegacyStyles();
  // Branch only for v1 (#36395): the other brands keep the old table until they sign off on it.
  const isRedesign = Boolean(appConfig?.featureFlags?.offerSearchRedesign);
  const columns = isRedesign ? COLUMNS : LEGACY_COLUMNS;
  const headerCellClass = isRedesign ? classes.headerCell : legacyClasses.headerCell;
  const Row = isRedesign ? OfferItem : LegacyOfferItem;

  return (
    <>
      {showHeader && (
        <Label type="subtitle" style={{ marginBottom: 16 }}>
          Offers
        </Label>
      )}

      <Paper>
        {Boolean(loading || hits.length) && (
          <Table
            selfContained={false}
            loading={loading}
            paginationEnabled
            count={totalHits}
            rowsPerPage={hits.length}
            currentPage={page}
            onPageChange={(_, page) => onPageChange(page)}
            header={columns.map(([columnId, label]) => (
              <TableHeaderCell key={columnId} tableClasses={headerCellClass} columnId={columnId}>
                {label}
              </TableHeaderCell>
            ))}
            body={Boolean(hits && hits.length) && hits.map((hit) => <Row key={hit.id} offer={hit} />)}
          />
        )}
        {!loading && hits.length === 0 && <NoResults error={error} />}
      </Paper>
    </>
  );
};

OffersResults.propTypes = {
  loading: PropTypes.bool.isRequired,
  hits: PropTypes.array,
  totalHits: PropTypes.number,
  page: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  showHeader: PropTypes.bool.isRequired,
  error: PropTypes.object
};

OffersResults.defaultProps = {
  hits: [],
  totalHits: 0
};

export default memo(OffersResults);
